import type { FC } from 'react'

import { Helmet } from 'react-helmet-async'

type FaviconProps = {
  href: string
}

const Favicon: FC<FaviconProps> = ({ href }) => (
  <Helmet>
    <link href={href} rel='shortcut icon' />
  </Helmet>
)

export default Favicon
